// @flow

import React from "react";
import { localize } from "redux-i18n";

import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "@components";
import type { SpecialContactsType } from "@modules/service/reducer/special-contacts-types/types";

type Props = {
  specialContactType: SpecialContactsType,
  onCancel: () => void,
  onSubmit: () => void,
  ...PropsFromLocalize,
};

export const RemoveSpecialContactTypeModal = (props: Props) => (
  <Modal className="modal-normal">
    <ModalHeader toggle={props.onCancel} className="d-flex justify-content-between">
      {props.t("REMOVE_SPECIAL_CONTACT_TYPE_MODAL_TITLE")}
    </ModalHeader>
    <ModalBody className="d-flex justify-content-center align-items-center">
      <p>
        {props.t("REMOVE_SPECIAL_CONTACT_TYPE_CONFIRMATION", {
          specialContactType: props.specialContactType.name,
        })}
      </p>
    </ModalBody>
    <ModalFooter className="d-flex justify-content-end">
      <Button color="secondary" onClick={props.onCancel}>
        {props.t("CANCEL")}
      </Button>
      <Button materialIcon="delete_forever" onClick={props.onSubmit}>
        {props.t("DELETE")}
      </Button>
    </ModalFooter>
  </Modal>
);

export default localize()(RemoveSpecialContactTypeModal);
